import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IUser } from "../../../Pages/User/IUser";

export const ListSettingResetSlice = createSlice({
  name: "ListSettingResetSlice",
  initialState: {} as IReduxState<IUser[]>,
  reducers: {
    listSettingReset: (state) => {
      state.isLoading = true;
    },
    successlistSettingReset: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistSettingReset: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearSettingResetResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  failurelistSettingReset,
  listSettingReset,
  successlistSettingReset,
  clearSettingResetResponse,
} = ListSettingResetSlice.actions;

export default ListSettingResetSlice.reducer;
